module.exports = __webpack_public_path__ + "img/p4-img1-d1-3.530f5bd4.png";